import React from 'react';

import { IndexGridNew } from '@rockerbox/styleguide';

import { TreeTableLoader } from '../../../components/loaders';
import { getBasicColumns } from '../columns';

const Views = ({ loading, data, manage_params }) => {
  if (loading) return <TreeTableLoader />;

  return (
    <IndexGridNew
      data={data}
      cols={getBasicColumns(manage_params)}
      sortable
      defaultSortCol="created_at"
      itemsPerPage={10}
      paginate
    />
  );
};

export default Views;
